import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/Store';
import App from './App';
import './index.css';
import  '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import  '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js'

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  
   
      <App />
 
  
);
